import { AnimatePresence } from "motion/react";
import { Cursor as MotionCursor } from "motion-plus/react";

type CursorProps = {
  show: boolean;
  label: string;
};

export function Cursor({ show, label }: CursorProps) {
  return (
    <AnimatePresence>
      {show ? (
        <MotionCursor
          follow
          offset={{ x: -40, y: -40 }}
          initial={{ scale: 0.5 }}
          animate={{ scale: 1 }}
          exit={{ scale: 0.5, opacity: 0 }}
          variants={{
            exit: { opacity: 0 },
          }}
          spring={{
            duration: 0,
          }}
        >
          <div className='w-20 h-20 rounded-full bg-brand-blue flex items-center justify-center'>
            <span className='text-white text-xs font-semibold tracking-wider'>
              {label}
            </span>
          </div>
        </MotionCursor>
      ) : null}
    </AnimatePresence>
  );
}
